// Parent Progress tab: concise Exam Prep summaries (strong/weak map + best
// mock score — never the tutoring transcript).
import { useEffect, useState } from "react";
import { GraduationCap } from "lucide-react";
import { api } from "../../lib/api";

const PHASE = { diagnostic: "Check-up in progress", study: "Studying with Pip", done: "Ready for the test!" };

export const ExamPrepSummaryCard = () => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    api.get("/exam/family/summary")
      .then(({ data }) => setRows(data.summaries || []))
      .catch(() => setRows([]));
  }, []);
  if (!rows.length) return null;
  return (
    <section className="bg-card rounded-2xl border border-border p-5"
      data-testid="exam-summary-card">
      <h2 className="text-base md:text-lg font-bold font-display flex items-center gap-2 mb-3">
        <GraduationCap className="h-5 w-5 text-secondary" aria-hidden="true" />
        Exam Prep sessions
      </h2>
      <div className="space-y-2">
        {rows.map((s) => (
          <button key={s.exam_id} type="button"
            onClick={() => setOpen(open === s.exam_id ? null : s.exam_id)}
            className="w-full text-left rounded-xl border border-border p-3 hover:border-rose-300"
            data-testid={`exam-summary-${s.exam_id}`}>
            <div className="flex justify-between gap-2 text-sm">
              <span className="font-bold">{s.child_name}: {s.title}</span>
              <span className="text-xs text-muted-foreground shrink-0">{s.date}</span>
            </div>
            <p className="text-xs text-muted-foreground mt-1">
              {PHASE[s.phase] || s.phase} · {s.mastered}/{s.concepts} mastered
              {s.best_mock_score != null && ` · best mock ${s.best_mock_score}%`}
            </p>
            {open === s.exam_id && (
              <div className="mt-2 text-xs space-y-1" data-testid={`exam-summary-detail-${s.exam_id}`}>
                {s.strong.length > 0 && (
                  <p><span className="font-bold">Strong:</span> {s.strong.join(", ")}</p>
                )}
                {s.needs_work.length > 0 && (
                  <p className="text-amber-700">
                    <span className="font-bold">Needs work:</span> {s.needs_work.join(", ")}
                  </p>
                )}
              </div>
            )}
          </button>
        ))}
      </div>
    </section>
  );
};
